import { useOrders } from "../hooks/useData";

const statusConfig = {
  pending: { label: "À confirmer", color: "bg-amber-100 text-amber-800" },
  waiting: { label: "En attente", color: "bg-blue-100 text-blue-800" },
  confirmed: { label: "Confirmé", color: "bg-green-100 text-green-800" },
  rejected: { label: "Refusé", color: "bg-red-100 text-red-800" },
  payment_sent: { label: "Paiement reçu", color: "bg-amber-100 text-amber-800" },
};

function formatDate(dateStr) {
  if (!dateStr) return "";
  return new Date(dateStr).toLocaleDateString("fr-FR", {
    day: "numeric", month: "long", hour: "2-digit", minute: "2-digit"
  });
}

export default function Orders() {
  const { orders, loading, confirmOrder, rejectOrder } = useOrders();

  const pending = orders.filter(o => o.status === 'pending').length;
  const confirmed = orders.filter(o => o.status === 'confirmed').length;
  const revenue = orders
    .filter(o => o.status === 'confirmed')
    .reduce((sum, o) => sum + (o.amount || 0), 0);

  return (
    <div className="space-y-4">

      {/* Résumé */}
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {[
          { label: "À confirmer", value: pending, color: "text-amber-600" },
          { label: "Confirmées", value: confirmed, color: "text-green-600" },
          { label: "Total commandes", value: orders.length, color: "text-gray-800" },
          { label: "Revenus confirmés", value: `${(revenue/1000).toFixed(0)}k FCFA`, color: "text-orange-600" },
        ].map((s, i) => (
          <div key={i} className="bg-white rounded-xl border border-gray-100 p-4">
            <div className="text-xs text-gray-500 mb-1">{s.label}</div>
            <div className={`text-xl font-medium ${s.color}`}>
              {loading ? "..." : s.value}
            </div>
          </div>
        ))}
      </div>

      {/* Liste commandes */}
      <div className="bg-white rounded-xl border border-gray-100 overflow-hidden">
        <div className="px-4 py-3 border-b border-gray-100">
          <span className="text-sm font-medium text-gray-800">Toutes les commandes</span>
        </div>
        {loading ? (
          <div className="px-4 py-6 text-center text-sm text-gray-400">Chargement...</div>
        ) : orders.length === 0 ? (
          <div className="px-4 py-6 text-center text-sm text-gray-400">Aucune commande</div>
        ) : (
          orders.map((o, i) => (
            <div key={i} className="px-4 py-3 border-b border-gray-50 last:border-0">
              <div className="flex items-center justify-between mb-1">
                <span className="text-sm font-medium text-gray-800">
                  {o.contacts?.phone || 'Client'}
                </span>
                <span className="text-sm font-medium text-orange-600">
                  {o.amount?.toLocaleString()} FCFA
                </span>
              </div>
              <div className="text-xs text-gray-500 mb-1">
                {o.payment_method || 'Paiement mobile'}
              </div>
              <div className="text-xs text-gray-400 mb-2">
                {formatDate(o.created_at)}
              </div>
              <div className="flex items-center gap-2">
                <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${statusConfig[o.status]?.color || 'bg-gray-100 text-gray-800'}`}>
                  {statusConfig[o.status]?.label || o.status}
                </span>
                {o.status === "pending" && (
                  <div className="flex gap-2 ml-auto">
                    <button
                      onClick={() => confirmOrder(o.id)}
                      className="px-3 py-1 bg-green-50 text-green-700 border border-green-200 rounded-lg text-xs font-medium hover:bg-green-100"
                    >
                      Confirmer
                    </button>
                    <button
                      onClick={() => rejectOrder(o.id)}
                      className="px-3 py-1 bg-red-50 text-red-700 border border-red-200 rounded-lg text-xs font-medium hover:bg-red-100"
                    >
                      Refuser
                    </button>
                  </div>
                )}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}